export default __webpack_public_path__ + "static/media/piechart-icon.810441cc.svg";